/*!

=========================================================
* Paper Dashboard React - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/paper-dashboard-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)

* Licensed under MIT (https://github.com/creativetimofficial/paper-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React  from "react";
import { createBrowserHistory } from "history";
import { useClearBrowserCache } from 'react-clear-browser-cache';
 
import 'react-big-calendar/lib/css/react-big-calendar.css';

import 'moment/locale/pt-br';
//Context
import AuthProvider from "context/auth";
import { DashboardProvider } from "context/DashboardContext";

import RoutesComponent from "./RoutesComponent";

 
export default function App() {
    const contextValue = useClearBrowserCache();
    return (
        <DashboardProvider>
            <AuthProvider>
                <RoutesComponent/>
            </AuthProvider>
        </DashboardProvider>
    )
}
